import { IAppContext } from 'App/AppContext';
import { TFunction } from 'i18next';
import AppError from 'utils/appError';

/**
 * The translated sentence for a refusal the API explained with a code (a DOCPROV code, or
 * IP0001 for a permission), or undefined for anything else: a network failure, a bug, an
 * MSAL error. Those keep the scene-level error with its logging.
 */
export const getBrokeredErrorMessage = (err: unknown, t: TFunction<string[]>): string | undefined => {
  return AppError.getControllerExceptionMsg(AppError.fromApiError(err), t);
};

/**
 * For an action that failed (a folder that could not be created, a file that did not
 * upload): a refusal the API explained goes bottom-centre, where a user inside the modal
 * is looking; the scene-level bar lands behind the modal chrome. Anything else is
 * unexpected and keeps the scene-level error with its logging.
 *
 * A listing that failed is not an action: it uses an inline message that stays on
 * screen, because a toast is gone in four seconds and an empty grid then reads as an
 * empty folder.
 */
export const notifyBrokeredError = (appContext: IAppContext, err: unknown, t: TFunction<string[]>) => {
  const msg = getBrokeredErrorMessage(err, t);

  if (msg) {
    appContext.showNotification(msg, true, false, true);
  } else {
    appContext.setError(err);
  }
};
